import { User } from '@bimdata/definitions/dto';
import api from './api';

async function get(id: string): Promise<User | null> {
  try {
    const { data } = await api.get<User>(`/user/${id}`);
    return data;
  } catch (error) {
    if (error.code !== 404) {
      throw error;
    }
  }
  return null;
}

async function search(q?: string): Promise<Array<User>> {
  const { data } = await api.get<Array<User>>(`/user/search${q ? `?q=${q}` : ''}`);
  return data;
}

async function getAvatar(id: string, avatar: number): Promise<string | null> {
  try {
    const { data } = await api.get(`/user/avatar/${id}?v=${avatar}`, { responseType: 'blob' });
    return URL.createObjectURL(data);
  } catch (error) {
    if (error.code !== 404) {
      throw error;
    }
  }
  return null;
}

export {
  search,
  getAvatar,
  get
};